import DynamicHeader from './scripts/DynamicHeader';
import MobileMenu from './scripts/MobileMenu';
import RevealOnScroll from './scripts/RevealOnScroll';
//import SmartMenu from './scripts/SmartMenu';
//import { LuminousGallery } from 'luminous-lightbox';
import Swiper from 'swiper/bundle';



new DynamicHeader();
new MobileMenu();
new RevealOnScroll();

//new SmartMenu();
//const lumis = document.querySelectorAll('.lumi');
//lumis.length && new LuminousGallery(lumis);
// new LuminousGallery(
//     document.querySelectorAll(".lumi"),
//     {
//       arrowNavigation: true
//     },
//     {
//       caption: function(trigger) {
//         return trigger.querySelector("img").getAttribute("alt");
//       }
//     }
//   );

new Swiper(".swiper-testimonials", {
slidesPerView: 2,
spaceBetween: 40,
autoplay: {
    delay: 7000,
},
loop: true,
pagination: {
    el: ".swiper-pagination",
    clickable: true,
},
// Enable swipe on all devices (default)
breakpoints: {
    0: {
    slidesPerView: 1,
    },
    768: {
    slidesPerView: 2,
    }
}
});

new Swiper(".swiper-projekte", {
    slidesPerView: 1,
    loop: true,
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },
    });